import {  overview } from '@/api/order'

const order = {
  state: {
    
     orderOverviewResp: {},
  },

  actions: {
    // 订单详细
    OrdrOverview() {
      return new Promise((resolve, reject) => {
        overview().then(response => {
        this.orderOverviewResp = response.data
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

  }
}

export default order



// WEBPACK FOOTER //
// ./src/store/modules/order.js